import { z } from 'zod';

export const jobCardItemSchema = z.object({
  id: z.number().optional(),
  item_id: z.number({ required_error: 'Item is required' }),
  quantity: z.number().min(0.01, 'Quantity must be greater than 0'),
  unit_id: z.number({ required_error: 'Unit is required' }),
  rate: z.number().min(0, 'Rate must be 0 or greater'),
  discount_percent: z.number().min(0).max(100).optional().default(0),
  discount_amount: z.number().min(0).optional().default(0),
  tax_rate_id: z.number().nullable().optional(),
  notes: z.string().nullable().optional(),
  technician_id: z.number().nullable().optional(),
  estimated_duration_minutes: z.number().nullable().optional(),
  completion_status: z.enum(['pending', 'in_progress', 'completed', 'skipped']).optional().default('pending'),
});

export const vehicleCheckedItemsSchema = z.object({
  exterior_scratches: z.string().nullable().optional(),
  exterior_dents: z.string().nullable().optional(),
  spare_tire: z.boolean().optional(),
  jack_tools: z.boolean().optional(),
  documents: z.boolean().optional(),
  valuables_note: z.string().nullable().optional(),
});

export const jobCardSchema = z.object({
  vehicle_id: z.number({ required_error: 'Vehicle is required' }),
  transaction_date: z.date({ required_error: 'Date is required' }),
  site_id: z.number().nullable().optional(),
  party_id: z.number().nullable().optional(),
  reference_number: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
  customer_complaint: z.string().nullable().optional(),
  technician_observations: z.string().nullable().optional(),
  job_card_type: z.enum([
    'regular_service',
    'repair',
    'detailing',
    'accidental',
    'warranty',
    'pdi',
  ]).nullable().optional(),
  priority: z.enum(['low', 'normal', 'high', 'urgent']).default('normal'),
  odometer_reading: z.number().nullable().optional(),
  fuel_level: z.enum(['empty', '1/4', '1/2', '3/4', 'full']).nullable().optional(),
  bay_number: z.string().nullable().optional(),
  lead_technician_id: z.number().nullable().optional(),
  estimated_completion_date: z.date().nullable().optional(),
  vehicle_checked_items: vehicleCheckedItemsSchema.nullable().optional(),
  items: z.array(jobCardItemSchema).optional().default([]),
});

export type JobCardFormValues = z.infer<typeof jobCardSchema>;
export type JobCardItemFormValues = z.infer<typeof jobCardItemSchema>;

export const defaultJobCardValues: JobCardFormValues = {
  vehicle_id: undefined as unknown as number, // Will be validated
  transaction_date: new Date(),
  site_id: null,
  party_id: null,
  reference_number: null,
  notes: null,
  customer_complaint: null,
  technician_observations: null,
  job_card_type: 'regular_service',
  priority: 'normal',
  odometer_reading: null,
  fuel_level: null,
  bay_number: null,
  lead_technician_id: null,
  estimated_completion_date: null,
  vehicle_checked_items: null,
  items: [],
};
